module.exports = "<p>\n  tenant works!\n</p>\n"